export function HarriIQSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/harriIQ.svg'"></ng-include>`
    }
}
            